module.exports = __webpack_public_path__ + "media/images/pic/team-5325209b0c5ad9fdc04e5a2b6e8c0c04.jpg";